import {MuWidget} from "mu-widget/lib/MuWidget";

export class WorklogEditor extends MuWidget {
    public afterIndex()
    {
        this.updateForm();
    }
    public endAsDtEnd_change()
    {
        this.updateForm();
        this.ui.dtEndInput.focus();
    }
    public endAsValue_change()
    {
        this.updateForm();
        this.ui.valueInput.focus();
    }
    public updateForm()
    {
        this.ui.dtEndInput.disabled = !this.ui.endAsDtEnd.checked;
        this.ui.valueInput.disabled = !this.ui.endAsValue.checked;
    }
}
/* var WorklogEditor = function(container) {
    // Datetime picker vytváří kopii inputu a kopíruje i mu-id, nastavím až před indexací
    container.querySelector("[name='dtEnd']").setAttribute("mu-id", "dtEndInput");
};
WorklogEditor.prototype = { */
